module.exports = __webpack_public_path__ + "static/img/12.cf3cf22.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/12.png
// module id = 89nH
// module chunks = 0